// extracted by mini-css-extract-plugin
export default {"container":"Yo-z","bubbleNav":"Zo-z","graphic":"_o-z","contact":"ap-z"};